import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import classNames from "classnames";

function ButtonSelect(props) {
  return _jsx("div", Object.assign({
    className: "d-inline-flex flex-row justify-content-center"
  }, {
    children: _jsx("div", Object.assign({
      className: "btn-group"
    }, {
      children: props.options.map(function (option) {
        return _jsx("button", Object.assign({
          type: "button",
          className: classNames("btn", "btn-outline-secondary", {
            active: props.value === option.value
          }, {
            "btn-sm": props.small || props.xSmall
          }),
          onClick: function onClick() {
            return props.handleChange(option.value);
          },
          style: props.xSmall ? {
            fontSize: "small"
          } : {}
        }, {
          children: option.label
        }), option.value);
      })
    }), void 0)
  }), void 0);
}

export default ButtonSelect;